import { SvgIcon } from '@mui/material'

// Types
import { SvgIconProps } from '@mui/material'

const TimerIconAtom = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 51 51">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={5}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M32.385 4.25H18.615C10.625 4.25 10.0087 11.4325 14.3225 15.3425L36.6775 35.6575C40.9912 39.5675 40.375 46.75 32.385 46.75H18.615C10.625 46.75 10.0087 39.5675 14.3225 35.6575L36.6775 15.3425C40.9912 11.4325 40.375 4.25 32.385 4.25Z"
			/>
		</SvgIcon>
	)
}

export default TimerIconAtom
